import React, { useState, useEffect, useRef } from "react";
import {
  Paper,
  InputBase,
  IconButton,
  Checkbox,
  ListItemText,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { FilterSelect } from "../CustomSelectBox";
import styles from "./styles";

let searchTimeout = null;

const SearchBox = ({
  className,
  style = {},
  iconStyle = {},
  placeholder = "Search",
  handleSearch = () => {},
  onChange = () => {},
  onInputChange = () => {},
  multiple = true,
  fields = [],
  selectedFields = [],
  query = "",
  setLoader = () => {},
}) => {
  const classes = styles();
  const [value, setValue] = useState(query || "");
  const inputRef = useRef(null);

  const handleChange = ({ target: { value = "" } }) => {
    setValue(value);
    onInputChange(value);
    triggerSearch(value);
  };

  const handlePaste = (e) => {
    setTimeout(() => {
      const newVal = inputRef.current ? inputRef.current.value : value;
      setValue(newVal);
      onInputChange(newVal);
      triggerSearch(newVal);
    }, 0);
  };

  const triggerSearch = (val = "") => {
    clearTimeout(searchTimeout);
    setLoader(true);
    searchTimeout = setTimeout(() => {
      handleSearch(val.trim());
      setLoader(false);
    }, 1000);
  };

  useEffect(() => {
    return () => {
      // cleanup debounce on unmount
      clearTimeout(searchTimeout);
    };
  }, []);

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        handleSearch(value.trim());
      }}
      style={{ width: "100%" }}
    >
      <Paper className={`${classes.searchBar} ${className || ""}`} style={{ ...style }}>
        <InputBase
          inputRef={inputRef}
          value={value}
          onChange={handleChange}
          onPaste={handlePaste}
          className={classes.input}
          placeholder={placeholder}
        />

        {fields.length > 1 && (
          <FilterSelect
            multiple={multiple}
            fields={fields}
            selectedFields={selectedFields}
            onChange={onChange}
          />
        )}

        <IconButton
          className={classes.iconButton}
          style={{ ...iconStyle }}
          aria-label="search"
          onClick={() => handleSearch(value.trim())}
          size="large">
          <SearchIcon className={classes.icon} />
        </IconButton>
      </Paper>
    </form>
  );
};

export default SearchBox;
